export default __webpack_public_path__ + "static/media/le_croise.b2f1e1f3.jpg";